export default __webpack_public_path__ + "static/media/ic_mlp_custom.06075f64.svg";